var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as userActions from 'src/store/actions/userActions';
import { Map } from 'immutable';
// - Material UI
import SvgDehaze from '@material-ui/icons/Dehaze';
import { blue } from '@material-ui/core/colors';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Paper from '@material-ui/core/Paper';
import SvgBag from '../../assets/images/checkoutBag';
import Hidden from '@material-ui/core/Hidden';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Tooltip from '@material-ui/core/Tooltip';
import { Manager, Target } from 'react-popper';
import { withStyles } from '@material-ui/core/styles';
import { getTranslate } from 'react-localize-redux';
import * as checkoutActions from 'store/actions/checkoutActions';
import PersonOutlineTwoToneIcon from '@material-ui/icons/PersonOutlineTwoTone';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PostWriteComponent from 'src/components/postWrite';
import SideDrawer from 'components/Drawer';
import 'react-tabs/style/react-tabs.css';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
// - Import components
import UserAvatarComponent from 'components/userAvatar';
import Notify from 'components/notify';
import './headerfront.css';
import { authorizeActions } from 'store/actions';
var drawerWidth = 305;
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            width: '100%',
            marginTop: theme.spacing.unit * .2,
            zIndex: 1,
            overflow: 'hidden',
        },
        appFrame: {
            position: 'relative',
            display: 'flex',
            width: '100%',
            height: '100%',
        },
        navIconHide: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _a),
        drawerHeader: theme.mixins.toolbar,
        drawerPaper: (_b = {
                maxWidth: drawerWidth,
                width: drawerWidth
            },
            _b[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                position: 'absolute',
                height: '50%',
                overflow: 'hidden'
            },
            // backgroundColor: 'red',    // background of side menu
            _b.backgroundImage = 'linear-gradient(#232526,#414345)',
            _b.borderRight = 0,
            _b.borderRadius = '15px',
            _b),
        drawerPaperLarge: (_c = {
                width: drawerWidth
            },
            _c[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                height: '100%',
                overflow: 'hidden'
            },
            _c.top = 0,
            _c.backgroundColor = 'white',
            // backgroundImage: 'linear-gradient(#232526,#414345)',
            _c.borderRight = 0,
            _c.borderRadius = '0px',
            _c),
        menu: {
            height: '100%',
        },
        content: (_d = {
                // backgroundImage: `url(https://media.idownloadblog.com/wp-content/uploads/2016/01/bokeh-snow-flare-water-white-splash-pattern-9-wallpaper.jpg)`,   // background of post component 
                // backgroundImage: 'linear-gradient(217deg, rgba(255,0,0,.3), rgba(255,0,0,0.2) 70.71%)',
                // backgroundImage: 'linear-gradient(#fff,#fff)',
                // backgroundImage: 'linear-gradient(#fdfbfb,#ebedee)',
                // linear-gradient(135deg, rgb(252, 253, 254), rgb(236, 239, 251), rgb(220, 225, 248))
                backgroundColor: 'white',
                width: '100%',
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                flexGrow: 1,
                padding: theme.spacing.unit * 0,
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                height: 'calc(100% - 56px)',
                marginTop: 47
            },
            _d[theme.breakpoints.up('sm')] = {
                height: 'calc(100% - 64px)',
                marginTop: 0,
            },
            _d),
        'content-left': {
            marginLeft: 0,
        },
        'content-right': {
            marginRight: 0,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        'contentShift-left': (_e = {
                marginLeft: 0
            },
            _e[theme.breakpoints.up('md')] = {
                marginLeft: 0 // controls how much content shifts when sidebar appears
            },
            _e),
        'contentShift-right': (_f = {
                marginRight: 0
            },
            _f[theme.breakpoints.up('md')] = {
                marginRight: 0 // controls how much content shifts when sidebar appears
            },
            _f)
    });
};
// - Create HomeHeader component class
var HomeHeaderComponent = /** @class */ (function (_super) {
    __extends(HomeHeaderComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function HomeHeaderComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            avatarStyle: {
                margin: 5,
                cursor: 'pointer'
            },
            icon: {
                color: '#d0ac74',
                fontSize: '1.12rem',
                fontFamily: 'Carrois Gothic SC, sans-serif'
            }
        };
        _this.header = React.createRef();
        /**
         * Handle close notification menu
         *
         *
         * @memberof HomeHeader
         */
        _this.handleOpenPostWrite = function () {
            _this.setState({
                openPostWrite: true
            });
        };
        _this.handleClosePostWrite = function () {
            _this.setState({
                openPostWrite: false
            });
        };
        _this.handleSelection = function () {
            if (_this.state.selected === 1) {
                _this.setState({ selected: 0 });
            }
            else {
                _this.setState({ selected: 1 });
            }
        };
        _this.handleCloseNotify = function () {
            _this.setState({
                openNotifyMenu: false
            });
        };
        // On click toggle sidebar
        _this.onToggleSidebar = function () {
            var onToggleDrawer = _this.props.onToggleDrawer;
            onToggleDrawer();
        };
        /**
         * Handle notification touch
         *
         *
         * @memberof HomeHeader
         */
        _this.handleNotifyTouchTap = function (event) {
            // This prevents ghost click.
            event.preventDefault();
            _this.setState({
                openNotifyMenu: true,
                anchorEl: event.currentTarget
            });
        };
        /**
         * Handle touch on user avatar for popover
         *
         *
         * @memberof HomeHeader
         */
        _this.handleAvatarTouchTap = function (event) {
            _this.setState({
                openAvatarMenu: true,
                anchorEl: event.currentTarget,
            });
        };
        /**
         * Handle logout user
         *
         *
         * @memberof HomeHeader
         */
        _this.handleLogout = function () {
            _this.props.logout();
        };
        /**
         * Handle close popover
         *
         *
         * @memberof HomeHeader
         */
        _this.handleRequestClose = function () {
            _this.setState({
                openAvatarMenu: false,
                anchorEl: null
            });
        };
        /**
         * Handle resize event for window to manipulate home header status
         * @param  {event} evt is the event is passed by winodw resize event
         */
        _this.handleResize = function (event) {
            var drawerStatus = _this.props.drawerStatus;
            // Set initial state
            var width = window.innerWidth;
            if (width >= 600 && !drawerStatus) {
                _this.onToggleSidebar();
            }
            else if (width < 600) {
            }
        };
        // Default state
        _this.state = {
            /**
             * User avatar popover is open if true
             */
            openAvatarMenu: false,
            /**
             * Show header title or not (true/false)
             */
            showTitle: true,
            /**
             * If true notification menu will be open
             */
            openNotifyMenu: false,
            selected: 1,
            isopen: false,
            FontColor: _this.props.FontColor || 'black',
            openPostWrite: false,
            hideTop: false
        };
        // Binding functions to `this`
        _this.onToggleSidebar = _this.onToggleSidebar.bind(_this);
        _this.handleCloseNotify = _this.handleCloseNotify.bind(_this);
        _this.handleSelection = _this.handleSelection.bind(_this);
        _this.handleOpenPostWrite = _this.handleOpenPostWrite.bind(_this);
        _this.handleClosePostWrite = _this.handleClosePostWrite.bind(_this);
        return _this;
    }
    HomeHeaderComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.loadUserInfo();
        /* iOS re-orientation fix */
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
            /* iOS hides Safari address bar */
            window.addEventListener('load', function () {
                setTimeout(function () {
                    window.scrollTo(0, 1);
                }, 1000);
            });
        }
        window.addEventListener('scroll', function () {
            var mount = _this.header.current;
            if (window.pageYOffset > 250) {
                _this.setState({ hideTop: true });
                if (mount) {
                    mount.style.backgroundColor = '#1b1b1b';
                }
            }
            else {
                _this.setState({ hideTop: false });
                if (mount) {
                    // mount.style.backgroundColor = 'transparent'
                }
            }
        });
        this.handleResize(null);
        if (window.outerWidth < 500) {
            this.setState({ FontColor: 'white' });
        }
        if (localStorage.getItem('arr')) {
            var storedState = localStorage.getItem('arr');
            var storedStateP = JSON.parse(storedState);
            storedStateP.forEach(function (post) {
                _this.props.AddPostToBag(Map(post));
            });
        }
    };
    // Render app DOM component
    HomeHeaderComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, translate = _a.translate, theme = _a.theme, goTo = _a.goTo;
        var anchor = theme.direction === 'rtl' ? 'right' : 'left';
        var style = {};
        var drawer = (React.createElement(React.Fragment, null,
            React.createElement(Divider, null),
            React.createElement("meta", { name: 'description', content: '3d Clothing' }),
            React.createElement("div", { onMouseLeave: function () { _this.setState({ isopen: false }); }, style: { fontFamily: 'Great Vibes' } },
                window.outerWidth < 600 ?
                    React.createElement("div", { style: { margin: 'auto' } }) :
                    React.createElement("div", null),
                React.createElement(Tabs, { className: 'FrontTabs', onSelect: this.handleSelection, selectedIndex: this.state.selected },
                    React.createElement(TabList, { style: { paddingLeft: '40px' } },
                        React.createElement(Tab, { style: { fontFamily: 'Askan-Light', fontSize: '20px' } }, "ACCOUNT"),
                        React.createElement(Tab, { style: { fontFamily: 'Askan-Light', fontSize: '20px' } }, "SHOP")),
                    React.createElement(TabPanel, null, this.props.uid ?
                        React.createElement("div", { style: { textAlign: 'left', } },
                            React.createElement("li", { style: { color: 'white' }, className: 'navItem2' },
                                React.createElement(NavLink, { className: 'navItem2', style: { color: 'white' }, to: "/feed" }, " News Feed ")),
                            React.createElement("li", { style: { color: 'white' }, className: 'navItem2' },
                                React.createElement(NavLink, { style: { color: 'white' }, to: "/profile/" + this.props.uid }, " Profile")),
                            React.createElement("li", { style: { color: 'white' }, className: 'navItem2' },
                                React.createElement(NavLink, { style: { color: 'white' }, to: "/people" }, " Designers")),
                            React.createElement("li", { style: { mixBlendMode: 'exclusion' }, className: 'navItem2' },
                                React.createElement(NavLink, { style: { mixBlendMode: 'exclusion' }, to: "/map" }, " Regions")),
                            React.createElement("li", { style: { color: 'white' }, className: 'navItem2' },
                                React.createElement(NavLink, { style: { color: 'white' }, to: "/checkout" }, " Checkout")))
                        :
                            React.createElement("div", { style: { textAlign: 'left', } },
                                React.createElement("li", { className: 'navItem2' },
                                    React.createElement(NavLink, { to: "/signin" }, " LOG IN")),
                                React.createElement("li", { className: 'navItem2' },
                                    React.createElement(NavLink, { to: "/signup" }, " SIGN UP")))),
                    React.createElement(TabPanel, null,
                        React.createElement("div", { style: { textAlign: 'left', } },
                            React.createElement("div", { style: { textAlign: 'left', color: 'white' } },
                                React.createElement("li", { className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'white' }, to: "/collection/Shirts" }, " Shirts")),
                                React.createElement("li", { className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'black' }, to: "/collection/Skincare" }, " Skincare")),
                                React.createElement("li", { className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'black' }, to: "/collection/Sweaters" }, " Sweatersss ")),
                                React.createElement("li", { style: { color: 'black' }, className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'black' }, to: "/collection/Hats" }, " Hatss ")),
                                React.createElement("li", { style: { color: 'black' }, className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'black' }, to: "/collection/Masks" }, " Masks ")),
                                React.createElement("li", { style: { color: 'black' }, className: 'navItem2' },
                                    React.createElement(NavLink, { style: { color: 'black' }, to: "/collection/Sneakers" }, " Sneakers ")))))))));
        if (window.outerWidth > 500) { // 500 
            return (React.createElement(AppBar, { ref: this.header, elevation: 0, className: 'header_Style', style: {
                    // backgroundColor: this.props.bgcolor || 'transparent',
                    boxShadow: '0', textAlign: 'center', width: '100%', position: this.props.position || 'fixed'
                } },
                this.state.hideTop === false ?
                    React.createElement("div", null,
                        React.createElement("div", { style: { float: 'left', width: '10%', verticalAlign: 'middle', marginTop: '2.1%' } },
                            React.createElement("div", { onMouseOver: function () { _this.setState({ isopen: !_this.state.isopen }); } },
                                React.createElement(IconButton, null,
                                    React.createElement(SvgDehaze, { style: { cursor: 'pointer', fontSize: '35px' } })))),
                        React.createElement(Hidden, { mdUp: true },
                            React.createElement(Drawer, { variant: 'temporary', open: this.state.isopen, classes: {
                                    paper: classes.drawerPaper,
                                }, onClose: function () { _this.setState({ isopen: false }); }, ModalProps: {
                                    keepMounted: true,
                                } },
                                React.createElement("div", null,
                                    React.createElement("div", { className: classes.drawerHeader }),
                                    React.createElement(MenuList, { style: { color: 'rgb(117, 117, 117)', width: '100%' } },
                                        React.createElement(Divider, null),
                                        React.createElement(SideDrawer, { setParentState: function (open) { _this.setState({ isopen: open }); }, uid: this.props.uid }))))),
                        React.createElement(Hidden, { smDown: true, implementation: 'js' },
                            React.createElement(Drawer, { variant: 'persistent', open: this.state.isopen, classes: {
                                    paper: classes.drawerPaperLarge,
                                } },
                                React.createElement("div", null,
                                    React.createElement(MenuList, { className: classes.menu, style: { color: 'white', width: '100%' } },
                                        React.createElement(SideDrawer, { setParentState: function (open) { _this.setState({ isopen: open }); }, uid: this.props.uid }))))),
                        React.createElement("div", { className: 'right_section', style: { float: 'right' } },
                            this.props.uid ?
                                React.createElement("div", { style: { margin: 'auto' } },
                                    React.createElement(UserAvatarComponent, { onClick: this.handleAvatarTouchTap, fullName: this.props.fullName, fileName: this.props.avatar, size: 30 }))
                                :
                                    React.createElement(NavLink, { to: '/signin' },
                                        React.createElement("div", { style: { float: 'left' } },
                                            React.createElement(PersonOutlineTwoToneIcon, { style: { color: this.props.FontColor || 'white' } }),
                                            React.createElement("div", { className: 'header_Signin', style: { color: 'white', verticalAlign: 'bottom', float: 'right', marginLeft: '10px' } }, "Sign In"))),
                            React.createElement("div", { className: 'section-item' },
                                React.createElement(NavLink, { className: 'section_item', to: '/checkout' },
                                    React.createElement(SvgBag, { color: this.state.FontColor || 'white', height: '25px', fontSize: '30px' }))),
                            this.props.isDesigner ?
                                React.createElement(PostWriteComponent, { open: this.state.openPostWrite, onRequestClose: this.handleClosePostWrite, edit: false },
                                    React.createElement(Paper, { elevation: 2 },
                                        React.createElement("div", null,
                                            React.createElement("button", { onClick: this.handleOpenPostWrite, className: 'section_item up_button' }, "Upload"))),
                                    React.createElement("div", { style: { height: '16px' } }))
                                : ''),
                        React.createElement("div", { style: { width: '20%', margin: 'auto', float: 'none', verticalAlign: 'center', maxWidth: '305px' } },
                            React.createElement("img", { onClick: function () { goTo('/'); }, style: { margin: 'auto', height: '70px', width: '55%', maxWidth: '305px', padding: '9px', cursor: 'pointer' }, src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/ht%20logo%20large.png?alt=media&token=4b1507c1-7742-4a4e-bff7-6c3f24eb4b73' })))
                    : React.createElement("div", null),
                !this.props.Hidenav ?
                    React.createElement("ul", { className: 'cont' },
                        React.createElement("li", { style: { color: this.state.FontColor || 'black' }, className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Shirts" }, " Shirts")),
                        React.createElement("li", { style: { color: this.state.FontColor || 'black' }, className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Skincare" }, " Skincare")),
                        React.createElement("li", { className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Sweaters" }, " Sweaters ")),
                        React.createElement("li", { className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Hats" }, " Hats ")),
                        React.createElement("li", { className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Masks" }, " Masks ")),
                        React.createElement("li", { className: 'navItem1' },
                            React.createElement(NavLink, { className: 'NavStyle', to: "/collection/Sneakers" }, " Sneakers "))) :
                    null,
                React.createElement(Menu, { open: this.state.openAvatarMenu, anchorEl: this.state.anchorEl, anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }, onClose: this.handleRequestClose },
                    React.createElement(MenuItem, { style: { fontSize: '14px' }, onClick: function () { _this.props.goTo("/profile/" + _this.props.uid); } }, " My Profile "),
                    React.createElement(MenuItem, { style: { fontSize: '14px' }, onClick: function () { _this.props.logout(); } }, " Logout"))));
        }
        return (React.createElement("div", { className: 'homeHeader__MOB' },
            React.createElement("div", { className: 'homeHeader__MOB' },
                React.createElement(AppBar, { className: 'header_Style', elevation: 0, classes: { root: classes.override }, position: 'fixed' },
                    React.createElement(Toolbar, null,
                        React.createElement(IconButton, { onClick: function () { _this.setState({ isopen: !_this.state.isopen }); } },
                            React.createElement(SvgDehaze, { color: 'primary', style: { cursor: 'pointer' } })),
                        React.createElement("img", { onClick: function () { goTo('/'); }, style: { marginLeft: '8px', height: '39px', width: '47%', maxWidth: '75px', padding: '4px', cursor: 'pointer' }, src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/HullthreadLogo%20with%20words.png?alt=media&token=eec0043d-91b2-4f6e-b5e7-1596f21d2ed3' }),
                        React.createElement("div", { className: 'homeHeader__title-root' }),
                        React.createElement(Hidden, { mdUp: true },
                            React.createElement(Drawer, { variant: 'temporary', open: this.state.isopen, classes: {
                                    paper: classes.drawerPaper,
                                }, onClose: function () { _this.setState({ isopen: false }); }, ModalProps: {
                                    keepMounted: true,
                                } },
                                React.createElement("div", null,
                                    React.createElement("div", { className: classes.drawerHeader }),
                                    React.createElement(MenuList, { style: { color: 'rgb(117, 117, 117)', width: '100%' } },
                                        React.createElement(Divider, null),
                                        React.createElement(SideDrawer, { setParentState: function (open) { _this.setState({ isopen: open }); }, uid: this.props.uid }))))),
                        React.createElement(Hidden, { smDown: true, implementation: 'js' },
                            React.createElement(Drawer, { variant: 'persistent', open: this.state.isopen, classes: {
                                    paper: classes.drawerPaperLarge,
                                } },
                                React.createElement("div", null,
                                    React.createElement(MenuList, { className: classes.menu, style: { color: 'rgb(117, 117, 117)', width: '100%' } },
                                        React.createElement(SideDrawer, { setParentState: function (open) { _this.setState({ isopen: open }); }, uid: this.props.uid }))))),
                        React.createElement("div", { className: 'menufronttest', style: { textAlign: 'justify', display: 'inline', zoom: '1.2', margin: 'auto', marginLeft: '5%' } },
                            React.createElement("div", { className: 'menufront-titletest menufront-title_2nd', style: { display: 'inline-block' } },
                                React.createElement(NavLink, { to: '/checkout' },
                                    React.createElement("div", { 
                                        // onMouseOver={this.showBag}
                                        // onMouseLeave={this.hideBag} 
                                        style: this.styles.icon },
                                        React.createElement(SvgBag, null))))),
                        React.createElement("div", { style: { paddingRight: '0px' }, className: 'homeHeader__right' },
                            this.props.uid ?
                                React.createElement(Manager, null,
                                    React.createElement(Target, null, this.props.notifyCount > 0 ? (React.createElement(Tooltip, { title: translate('header.notificationTooltip') },
                                        React.createElement(IconButton, { onClick: this.handleNotifyTouchTap },
                                            React.createElement("div", { className: 'homeHeader__notify' },
                                                React.createElement("div", { className: 'title' }, this.props.notifyCount)))))
                                        : (React.createElement(Tooltip, { title: translate('header.notificationTooltip') },
                                            React.createElement(IconButton, { onClick: this.handleNotifyTouchTap },
                                                React.createElement(NotificationsIcon, { style: { color: 'rgba(255, 255, 255, 0.87)' } }))))),
                                    React.createElement(Notify, { open: this.state.openNotifyMenu, anchorEl: this.state.anchorEl, onRequestClose: this.handleCloseNotify }))
                                : React.createElement("div", null),
                            this.props.avatar ?
                                React.createElement(UserAvatarComponent, { onClick: this.handleAvatarTouchTap, fullName: this.props.fullName, fileName: this.props.avatar, size: 42, style: this.styles.avatarStyle })
                                : React.createElement("div", null),
                            React.createElement(Menu, { open: this.state.openAvatarMenu, anchorEl: this.state.anchorEl, anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right'
                                }, transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right'
                                }, onClose: this.handleRequestClose },
                                React.createElement(MenuItem, { style: { backgroundColor: 'white', color: blue[500], fontSize: '14px' }, onClick: function () { _this.props.goTo("/profile/" + _this.props.uid); } },
                                    " ",
                                    translate('header.myAccount'),
                                    " "),
                                React.createElement(MenuItem, { style: { backgroundColor: 'white', color: blue[500], fontSize: '14px' } }, " My Purchases "),
                                React.createElement(MenuItem, { style: { fontSize: '14px' }, onClick: this.handleLogout.bind(this) },
                                    " ",
                                    translate('header.logout'),
                                    " "))))))));
    };
    return HomeHeaderComponent;
}(Component));
export { HomeHeaderComponent };
// - Map dispatch to props
var mapDispatchToProps = function (dispatch, ownProps) {
    var uid = ownProps.uid;
    return {
        logout: function () { return dispatch(authorizeActions.dbLogout()); },
        goTo: function (url) { return dispatch(push(url)); },
        loadUserInfo: function () { return dispatch(userActions.dbGetUserInfoByUserId(uid, 'header')); },
        AddPostToBag: function (post) { return dispatch(checkoutActions.addToBag(post)); },
    };
};
// - Map state to props
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], 0);
    var userNotifies = state.getIn(['notify', 'userNotifies']);
    var notifyCount = userNotifies
        ? userNotifies
            .filter(function (notification) { return !notification.get('isSeen', false); }).count()
        : 0;
    var user = state.getIn(['user', 'info', uid], {});
    return {
        uid: uid,
        isDesigner: user ? user.isDesigner : false,
        translate: getTranslate(state.get('locale')),
        avatar: user ? user.avatar : '',
        fullName: user ? user.fullName : '',
        title: state.getIn(['global', 'headerTitle'], ''),
        notifyCount: notifyCount
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(HomeHeaderComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/homeHeaderFrontPublic/FrontHeader.tsx
// module id = 1086
// module chunks = 0 1 2 4 5 6 18 19 20 21